import axios from "@/plugins/axios";
import { AxiosResponse } from "axios";
import CancellableHelper from "@/requests/CancellableHelper";
import SelectItem from "@/models/components/inputs/selectItem";

//#region Routes
export const URL_GET_OFFICES = "/Offices";
export const URL_GET_CULTURES = "/Office/Cultures";
//#endregion

export const getOffices = async (): Promise<AxiosResponse> => {
  return await axios.get(URL_GET_OFFICES);
};

const _getCultures = new CancellableHelper<Array<SelectItem>>(URL_GET_CULTURES);
export const getCultures = async (): Promise<Array<SelectItem>> => {
  return await _getCultures.get();
};
